module.exports = __webpack_public_path__ + "img/GOLD_APPLE.8cc4881c.png";